import { useDispatch } from "react-redux";

const HrFillDataInput = ({
    getValueFunc,
    inputValue,
    actionType,
    className,
    pattern,
    extraUtils,
    maxLength,
    inputPlaceholder,
    placeholder,
    isDisabled,
    style,
    inputType,
    classNames,
    defaultValue
}) => {
    return (
        <div style={style?.parentDiv} className={classNames?.parentDiv}>
            <div className={classNames?.placeHolderDiv} style={style?.placeHolderDiv}>
                {placeholder}
            </div>
            <input
                maxLength={maxLength}
                className={classNames?.input}
                style={style?.input}
                disabled={isDisabled}
                placeholder={inputPlaceholder}
                onChange={(e) => getValueFunc(e)}
                type={inputType}
                value={inputValue}
                pattern={pattern}
            />
        </div>
    );
};

export default HrFillDataInput;

// " hrDataInputs " + className
